import { useAuth } from '@/hooks/auth/use-auth';
import { useQueryParams } from '@/hooks/shared/use-query-params';
import { useMembershipsSuspense } from '../api/list-memberships';
import { MembershipList } from '../components/membership-list';
import { membershipToListItem } from '../utils/membership-list-item';
import { Card } from '@/shared/components/ui/card';
import { InviteMembers } from '@/features/invites/components/invite-members';
import { MembershipRole } from '@/types/api/membership';
import { Flyout } from '@/shared/components/flyout';
import { ErrorFrame } from '@/shared/components/error-frame';
import { Loader } from '@/shared/components/ui/loader';
import { MembershipPanel } from '../components/membership-panel';

const USER_ID_KEY = 'userId';

export function Memberships() {
  const { removeQueryParamByKey, getQueryParamByKey, setQueryParam } = useQueryParams();
  const groupId = useAuth().context!.groupId;
  const userId = getQueryParamByKey(USER_ID_KEY);

  const { data: memberships } = useMembershipsSuspense({ params: { groupId, include: ['user'] } });

  const handleFlyoutOpen = (open: boolean) => {
    if (!open) removeQueryParamByKey(USER_ID_KEY);
  };

  return (
    <>
      <div className="flex justify-between items-center mb-5">
        <div className="flex gap-2 items-center">
          <h1 className="text-2xl md:text-3xl text-gray-800 dark:text-gray-100 font-bold">Gruppmedlemmar</h1>
        </div>

        <InviteMembers roles={[MembershipRole.Member]} orgId={groupId} />
      </div>

      <Card className="p-0">
        <MembershipList
          items={memberships.map(membershipToListItem)}
          onRowClick={(userId) => setQueryParam(USER_ID_KEY, userId)}
        />
      </Card>

      <Flyout open={Boolean(userId)} setOpen={handleFlyoutOpen}>
        <ErrorFrame pendingFallback={<Loader absolute />}>
          {userId && <MembershipPanel groupId={groupId} userId={userId} />}
        </ErrorFrame>
      </Flyout>
    </>
  );
}
